module.exports = __webpack_public_path__ + "static/media/small_logo.5b4a7748.png";